import { Button } from '@here/components'
import { ArrowDown } from 'lucide-solid'
import { Show } from 'solid-js'
import { useService } from 'solid-services'
import { Box, Flex } from 'styled-system/jsx'
import { useUi } from '../../state'
import Notifications from './Notifications'

const MessageActions = (props: { scrollToBottom: () => void }) => {
	const { notAtBottom } = useService(useUi)()

	return (
		<Flex
			position="absolute"
			justifyContent="space-between"
			top={1}
			px={6}
			py={4}
			width="100%"
			zIndex={1}
		>
			{/* show when has messages */}
			<Box>
				<Notifications />
			</Box>

			<Box>
				<Show when={notAtBottom()}>
					<Button
						colorPalette="fg"
						size="xs"
						variant="subtle"
						onClick={props.scrollToBottom} // scroll to bottom if already have latest history, else load the latest history
					>
						Latest
						<ArrowDown />
					</Button>
				</Show>
			</Box>
		</Flex>
	)
}

export default MessageActions
